export default "__VITE_ASSET__wgiob7tk__"